var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSidebarSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "search",
    d: "M26.4741 27.6537L16.0383 17.2179C15.2049 17.9273 14.2466 18.4765 13.1633 18.8654C12.0799 19.2542 10.9913 19.4487 9.89744 19.4487C7.228 19.4487 4.96869 18.5247 3.11952 16.6766C1.27064 14.8286 0.346191 12.5706 0.346191 9.90286C0.346191 7.2348 1.27022 4.97494 3.11827 3.12327C4.96633 1.27188 7.22425 0.346191 9.89202 0.346191C12.5601 0.346191 14.8199 1.27064 16.6716 3.11952C18.523 4.96869 19.4487 7.228 19.4487 9.89744C19.4487 11.0555 19.2436 12.1762 18.8333 13.2595C18.423 14.3429 17.8845 15.2691 17.2179 16.0383L27.6537 26.4745L26.4741 27.6537ZM9.89744 17.782C12.1088 17.782 13.9758 17.0208 15.4983 15.4983C17.0208 13.9761 17.782 12.1091 17.782 9.89744C17.782 7.68577 17.0208 5.81883 15.4983 4.29661C13.9758 2.77411 12.1088 2.01286 9.89744 2.01286C7.68578 2.01286 5.81883 2.77411 4.29661 4.29661C2.77411 5.81883 2.01286 7.68577 2.01286 9.89744C2.01286 12.1091 2.77411 13.9761 4.29661 15.4983C5.81883 17.0208 7.68578 17.782 9.89744 17.782Z",
    fill: "#232323"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSidebarSearch);
export default __webpack_public_path__ + "static/media/sidebar_search.77d3eebc7047f2b901a5eaa5ce25b037.svg";
export { ForwardRef as ReactComponent };